import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  formatNameSelector,
  formatPropsSelector,
  inputSampleSelector
} from 'redux/schemaSlice';
import { schemaReceived } from 'redux/schemaSlice';
import { getSchemaRequestPayload } from 'utils/payloadUtils';
import { initGeometry } from 'redux/keyFieldsSlice';
import { requestSchema } from 'api';

import { notify } from 'components/Alert';

const useSchemaRequest = () => {
  const dispatch = useDispatch();
  const formatName = useSelector(formatNameSelector) || 'Unknown';
  const formatProps = useSelector(formatPropsSelector);
  const inputSample = useSelector(inputSampleSelector);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return {
    isLoading,
    requestSchema: async () => {
      try {
        setIsLoading(true);
        const response = await requestSchema(
          getSchemaRequestPayload(inputSample, formatName, formatProps)
        );
        if (!response.samples?.length) {
          throw Error('Failed fetching schema');
        }
        dispatch(schemaReceived(response));
        // Initialize key fields for e.g. esri-json
        if (response?.schema.geometry) {
          dispatch(initGeometry(response.schema.geometry));
        }
      } catch {
        notify({ message: 'Failed fetching schema' });
        throw Error('Failed fetching schema');
      } finally {
        setIsLoading(false);
      }
    }
  };
};

export default useSchemaRequest;
